import { render } from "./dispatchModal.vue?vue&type=template&id=a5b92c54"
import script from "./dispatchModal.vue?vue&type=script&lang=js"
export * from "./dispatchModal.vue?vue&type=script&lang=js"

import "./dispatchModal.vue?vue&type=style&index=0&id=a5b92c54&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__